const schemeRule = {
  required : [
    (v) => !!v || 'Medan ini adalah wajib diisi!',
  ],
  noIC : [
    (v) => !!v || 'Medan ini adalah wajib diisi!',
    (v) => /^\d+$/.test(v)||'Sila masukkan nombor sahaja',
    (v) => (v && v.length == 12) || 'Sila masukkan no kad pengenalan tanpa - dan 12 aksara',
  ],
  nama : [
    (v) => !!v || 'Medan ini adalah wajib diisi!',
    (v) => /^[a-zA-Z.'@\s]+$/.test(v)||'Hanya huruf dibenarkan',
  ],
  email : [
    (v) => /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(v)||'Email tidak sah'
  ],
  number :[
    
    //(v) => /^[0-9]+$/.test(v) || 'Hanya nombor dibenarkan'
    (v) => /^\d*$/.test(v) || 'Hanya nombor dibenarkan'
  ],
  poskod :[
    (v) => !!v || 'Medan ini adalah wajib diisi!',
    (v) => /^[0-9]+$/.test(v) || 'Hanya nombor dibenarkan'
  ],
  RM :[
    (v) => !!v || 'Medan ini adalah wajib diisi!',
    (v) => /^[0-9]+$/.test(v) || 'Hanya nombor dibenarkan',
    (v) => (v && v.length == 9) || 'Sila masukkan no kad pengenalan tanpa - dan 12 aksara',
  ],
  tarikhLahir:[
    (v) => !!v || 'Medan ini adalah wajib diisi!',
    (v) => /^(0[1-9]|[12][0-9]|3[01])\/(0[1-9]|1[0-2])\/\d{4}$/.test(v) || 'format haruslah dd/mm/yyyy'
  ],
  jarak: [
    (v) => !!v || 'Medan ini adalah wajib diisi!',
    (v) => /^[0-9]+$/.test(v) || 'Hanya nombor dibenarkan'
  ],
  jenisbarangRules: [
    (v) => !!v || 'Medan ini adalah wajib diisi!',
    (v) => /^[0-9]+$/.test(v) || 'Hanya nombor dibenarkan',
  ],
  no2digit: [
    (v) => !!v || 'Medan ini adalah wajib diisi!',
    (v) => (v && /^\d{0,2}$/.test(v)) || 'Sila masukkan maximum 2 digit nombor sahaja',
    
  ],
  no3digit: [
    (v) => !!v || 'Medan ini adalah wajib diisi!',
    (v) => (v && /^\d{0,3}$/.test(v)) || 'Sila masukkan maximum 3 digit nombor sahaja',
  ],
  
  no7digit: [
    (v) => !!v || 'Medan ini adalah wajib diisi!',
    (v) => (v && /^\d{0,7}$/.test(v)) || 'Sila masukkan maximum 7 digit nombor sahaja',
  ],
  // no8digit: [
  //   (v) => !!v || 'Medan ini adalah wajib diisi!',
  //   (v) => (v && /^\d{0,8}$/.test(v)) || 'Sila masukkan maximum 8 digit nombor sahaja',
  // ],
  // no8digit: [
  //   (v) => /^\d+$/.test(v)||'Sila masukkan nombor sahaja',
  //   //(v) => (v && v.length == 12) || 'Sila masukkan nombor dengan maksimum 8 digit',
  //   //(v) => !!v || 'Medan ini adalah wajib diisi!',
  //   //(v) => /^(?:[1-9]\d{0,9}|0)$/.test(v) || 'Sila masukkan nombor dengan maksimum 8 digit, termasuk digit perpuluhan'
  //   //(v) => (v && /^\d{1,8}(\.\d{1,8})?$/.test(v)) || 'Sila masukkan nombor dengan maksimum 8 digit, termasuk digit perpuluhan',
  // ],
  jumlahPeratus: [
    (v) => {
        if (!v) return true;
        const numValue = parseFloat(v);
        if (numValue !== 100) return 'Sila pastikan jumlah peratus adalah 100';
        return true;
    }
  ],
  noSahaja(){
    (v) => /^(?:[1-9]\d{0,5}|0)$/.test(v) || 'Nombor mesti 1 -9999'
  },

  noSahajaMandatori(){
    (v) => !!v || 'Medan ini adalah wajib diisi!',
    (v) => /^(?:[1-9]\d{0,5}|0)$/.test(v) || 'Nombor mesti 1 -9999'
  },

  

  

}

export default schemeRule;